import "./Cookies.css";
import Nav from "../../components/nav/Nav.jsx";
import Footer from "../../components/footer/Footer.jsx";
import React from "react";

const Cookies = () => {
    return (
        <>
            <Nav />
            <div className="root">
                <div className="root-ish">
                    <div className="container">
                        <div className="headerD divs">
                            <h2 className="heading">
                                Cookies and Similar Technologies Policy
                            </h2>
                            <p className="headSub">
                                This Cookie Policy takes effect on Dec 3, 2022.
                                Last updated on Dec 3, 2022
                            </p>
                        </div>
                        <div className="divs">
                            <h3 className="smheadings">
                                Information About Our Use of Cookies and Similar
                                Technologies
                            </h3>
                            <p className="paragraphs">
                                Applyforme (the “Applyforme Group,” “we,” “our,”
                                or “us”) wants to make sure you understand how
                                cookies and other similar technologies are used
                                by us on our websites applyforme.com and any
                                subdomains thereof (which we may refer to as the
                                “Sites”) and by our partners. These technologies
                                have several purposes (including third-party
                                advertising). Our Sites use cookies and similar
                                technologies to distinguish you from other users
                                of our Sites. This helps us to provide you with
                                a good experience when you browse our Sites and
                                also allows us to improve our Sites. By
                                continuing to browse any of our Sites, you are
                                agreeing to our use of cookies and similar
                                technologies as described in this Policy.
                            </p>
                        </div>
                        <div className="divs">
                            <h3 className="smheadings">
                                Types of Technologies That We Use
                            </h3>
                            <div className="paragraphs">
                                Cookies: A cookie is a small piece of data (text
                                file) that a website – when visited by a user –
                                asks your browser to store on your device in
                                order to remember information about you, such as
                                your language preference or login information.
                                Those cookies are set by us and called
                                “first-party cookies”. We also use “third-party
                                cookies” – which are cookies originating from a
                                domain different from the domain of the website
                                you are visiting (e.g., one of our Sites) –
                                generally for our advertising and marketing
                                efforts. More specifically, we use cookies and
                                other tracking technologies for the following
                                purposes: to enable our Sites to function and
                                mainta in security (for example, shopping cart
                                functionality, security, customer support); to
                                track, measure, and improve performance of our
                                Sites; allow personalization of our Sites; and
                                to target our own ads to prior visitors of our
                                Sites on third party websites (see below on “Why
                                We Use Cookies and Similar Technologies”).
                                <ul>
                                    <li className="lis">
                                        A persistent cookie remains on your hard
                                        drive after you close your browser.
                                        Persistent cookies may be used by your
                                        browser on subsequent visits to one of
                                        our Sites until you choose to delete
                                        them, and otherwise typically delete
                                        themselves at expiration. Persistent
                                        cookies can be removed by following your
                                        web browser's directions.
                                    </li>
                                    <li className="lis">
                                        A session cookie is temporary and
                                        disappears after you close your browser.
                                    </li>
                                    <li className="lis">
                                        A third-party cookie is placed by
                                        someone other than the applyforme Group,
                                        and may gather browsing activity across
                                        multiple websites and across multiple
                                        sessions. They are usually a type of
                                        persistent cookie and are stored until
                                        you delete them or they expire based on
                                        the time set in each third-party cookie.
                                    </li>
                                </ul>
                                You can reset your web browser to refuse all
                                cookies or to indicate when a cookie is being
                                sent. However, some features of our service may
                                not function properly if the ability to accept
                                cookies is disabled. For more information about
                                cookies, you may visit{" "}
                                <span>http://www.allaboutcookies.org</span>.
                            </div>
                        </div>
                        <div className="divs">
                            <h3 className="smheadings">
                                Why We Use Cookies and Similar Technologies
                            </h3>
                            <div className="paragraphs">
                                We use cookies and similar technologies
                                described above to recognize your logged-in
                                state on the Sites, to understand what purchases
                                members and visitors are interested in, to make
                                our Sites function for you, and to help your
                                browsing experience and use of the Sites feel
                                more customized, as further described:
                                <ul>
                                    <li>
                                        Strictly necessary. These are cookies
                                        that are required for the operation of
                                        our Sites or to provide the services
                                        requested by you. They include, for
                                        example, cookies that enable you to log
                                        into secure areas of our Sites, use a
                                        shopping cart, or make use of e-billing
                                        services.
                                    </li>
                                    <li>
                                        Functional. These are used to recognize
                                        you when you return to our Sites. This
                                        enables us to personalize our content
                                        for you, greet you by name and remember
                                        your preferences (for example, your
                                        choice of language or region).
                                    </li>
                                    <li>
                                        Analytical/performance. They allow us to
                                        recognize and count the number of
                                        visitors and to see how visitors move
                                        around our Sites when they are using the
                                        Sites. This helps us to improve the way
                                        our Sites work, for example, by ensuring
                                        that users are finding what they are
                                        looking for easily.
                                        <ul>
                                            <li>
                                                Google Analytics: The Site also
                                                uses Google Analytics to help
                                                understand how our Service is
                                                used by its community. For some
                                                of the advertising features
                                                listed below, like retargeting,
                                                data from Google Analytics may
                                                be combined with our first-party
                                                data and third-party cookies
                                                (like Google’s advertising
                                                cookies). See here for how
                                                Google uses data when you use
                                                our Service and how you may opt
                                                out (
                                                <span>
                                                    www.google.com/policies/privacy/partners/
                                                </span>
                                                ).
                                            </li>
                                            <li>
                                                Other Analytics Providers. We
                                                also use other third-party
                                                analytics services, including
                                                LinkedIn Analytics, Sift, and
                                                Segment. We use these analytics
                                                providers to help understand use
                                                of the Sites. These analytics
                                                services collect the information
                                                sent by your browser as part of
                                                a web page request, including
                                                cookies and your IP address, and
                                                their use of this information is
                                                governed by their privacy
                                                policies. You can find links to
                                                their privacy policies below, in
                                                the “Managing Cookies
                                                Technologies” section.
                                            </li>
                                        </ul>
                                    </li>
                                    <li>
                                        Social Networks. These are used to
                                        enable you to interact with third-party
                                        social-networks when logged into our
                                        Sites (subject to any preferences you
                                        set with those third-parties). Social
                                        networks may also work with us or with
                                        you for analytics or for marketing
                                        purposes, as discussed below. You may be
                                        able to manage your privacy preferences
                                        for these social networks and their
                                        tools and widgets via your account with
                                        the social network. You can find links
                                        to their privacy policies below in the
                                        “Managing Cookies Technologies” section.
                                    </li>
                                    <li>
                                        Targeting and Marketing. For third party
                                        advertising on our Sites (e.g., Font
                                        Squirrel), third parties that deliver
                                        ads on our Sites use cookies on our
                                        Sites with our permission to uniquely
                                        distinguish your web browser and keep
                                        track of information relating to serving
                                        ads on your web browser, such as the
                                        type of ads shown and the web pages on
                                        which the ads appeared in order to
                                        provide ads on our Sites that we hope
                                        will be of interest to you. We also work
                                        with third-parties to target advertising
                                        for our Sites on the third-party
                                        websites. These cookies record your
                                        visit to our Sites, the pages you have
                                        visited and the links you have followed.
                                        We will use this information to make our
                                        Sites more relevant to your interests.
                                        We may also share this information with
                                        third parties for this purpose. These
                                        third-party service providers may use
                                        various cookies and similar technology
                                        to permit us and them to show you ads on
                                        third-party websites. These may include
                                        things such as:
                                        <ul>
                                            <li>
                                                Frequency capping, which limits
                                                the number of times a user’s
                                                browser or mobile device
                                                displays the same ad;
                                            </li>
                                            <li>
                                                Attribution tracking, which
                                                estimates what advertising or
                                                marketing source brought someone
                                                to our Sites, or determines what
                                                marketing source led to actions
                                                like a visit or a purchase;
                                            </li>
                                            <li>
                                                Remarketing, which shows
                                                relevant ads to an audience
                                                based on prior shopping and
                                                browsing patterns on our Sites;
                                            </li>
                                            <li>
                                                Audience targeting, which refers
                                                to targeting advertisements to a
                                                large audience based on the
                                                audience’s known or inferred
                                                demographics; and
                                            </li>
                                            <li>
                                                Cross-device recognition, which
                                                recognizes actions across
                                                multiple devices or browsers.
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                Some third-party service providers may provide
                                information like demographics, cross-device
                                information, or interest categories from a
                                combination of sources that, while not
                                identifying you personally, permit us to provide
                                you with more relevant and useful advertising.
                                In some cases, this information may have
                                non-marketing performance analytics uses as
                                well. These technologies allow a partner to
                                recognize your computer or mobile device each
                                time you visit our Sites or other websites and
                                mobile applications based on data like a cookie,
                                your IP address, or device ID, but do not allow
                                access to other personal information from our
                                Sites. However, these technologies may allow us
                                or a third party to recognize you, either from a
                                single device or across devices, over time.
                                These third parties are required to follow
                                applicable laws, self-regulatory programs, and
                                our data protection rules where applicable.
                                However, Dribbble Group does not have control
                                over these third parties, who each have their
                                own privacy policies and privacy practices.
                                <br></br>
                                You can find links to their privacy policies
                                below in the “Managing Cookies Technologies”
                                section.
                            </div>
                        </div>
                        <div className="divs">
                            <h3 className="smheadings">
                                Consent, Contract, and Legitimate Interests in
                                Processing
                            </h3>
                            <p className="paragraphs">
                                Certain Cookie Technologies are employed to make
                                each of our Sites function for its intended
                                purpose, and are provided based on contractual
                                necessity based on your agreement with Dribbble
                                Group to perform the services you have
                                requested. These include the functions strictly
                                necessary to the service noted above.<br></br>
                                By choosing to use our Sites after having been
                                notified of our use of Cookie Technologies in
                                the ways described in this Policy, and, in
                                applicable jurisdictions, through notice and
                                unambiguous acknowledgement of your consent, you
                                agree to such use.
                            </p>
                        </div>
                        <div className="divs">
                            <h3 className="smheadings">
                                Managing Cookie Technologies
                            </h3>
                            <div className="paragraphs">
                                You have the ability to control the use of
                                certain cookies and similar technologies.{" "}
                                <br></br>
                                <br></br>
                                Opt-in and Opt-out on BrowsersYou may block
                                cookies by activating the setting on your
                                browser that allows you to refuse the setting of
                                all or some cookies. However, if you use your
                                browser settings to block all cookies (including
                                essential cookies) you may not be able to access
                                all or parts of our Sites.<br></br>
                                <br></br>
                                Opt-out of Third-Party NetworksFor more
                                information about third-party ad networks and
                                services that use these technologies, and the
                                ability to-opt out from tracking by
                                participating vendors, you can visit{" "}
                                <span>www.aboutads.info</span> or, if you are in
                                the EU (
                                <span>http://youronlinechoices.eu/</span>). You
                                also may visit the NAI’s site for additional
                                options on how to opt out of interest-based
                                advertising (at{" "}
                                <span>
                                    https://optout.networkadvertising.org
                                </span>
                                ).
                                <br></br>
                                <br></br>
                                Google Analytics Opt-outFor Google Analytics
                                Advertising Features, you can opt-out through
                                Google Ads Settings, Ad Settings for mobile
                                apps, or any other available means (for example,
                                the NAI's consumer opt-out listed above). You
                                may find out more and opt-out here:{" "}
                                <span>
                                    www.google.com/policies/privacy/partners/
                                </span>{" "}
                                and Opt-out here{" "}
                                <span>https://adssettings.google.com.</span>
                                <br></br>
                                <br></br>
                                Additional Third-Party Cookies and Similar
                                Technologies Used on the Site.
                            </div>
                        </div>
                        <div className="divs">
                            <h3 className="smheadings">Third-Party Tools</h3>
                            <p className="paragraphs">
                                Various third parties provide browser plug-ins
                                and apps that can help provide you information
                                on, and limit or block, third-party cookies, web
                                beacons, and some Javascript-based technologies.
                                We cannot vouch for the efficacy of a particular
                                third-party product, but popular products that
                                provide these privacy enhancements include
                                Ghostery and AdBlock Plus.
                            </p>
                        </div>
                        <div className="divs">
                            <h3 className="smheadings">Contact Us</h3>
                            <div className="paragraphs">
                                If you have questions about our use of cookies
                                and similar technologies, please see the “
                                <span>
                                    {" "}
                                    <a href="/contact">Contact Us</a>
                                </span>
                                ” section of our{" "}
                                <span>
                                    {" "}
                                    <a href="Privacy.jsx">Privacy Policy</a>
                                </span>
                                .
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default Cookies;
